var _defs, _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCargardocumentos(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #d1d1d1;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #0c0c0c;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: none;\r\n        stroke: #04808f;\r\n        stroke-miterlimit: 10;\r\n        stroke-width: .75px;\r\n      }\r\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 5.2,
    y: 2.81,
    width: 19.6,
    height: 24.75,
    rx: 4.27,
    ry: 4.27,
    transform: "translate(-.19 30.19) rotate(-90)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.78,12.34c-.15-1.96-1.79-3.51-3.78-3.51s-3.63,1.55-3.78,3.51c-1.46,.05-2.64,1.26-2.64,2.73s1.23,2.73,2.73,2.73h7.37c1.51,0,2.73-1.23,2.73-2.73s-1.18-2.68-2.64-2.73Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M12.68,17.41c.15,.15,.4,.15,.56,0l1.37-1.37v5.11c0,.22,.18,.4,.4,.4s.4-.18,.4-.4v-5.07l1.37,1.34c.16,.15,.41,.15,.56,0,.15-.16,.15-.41,0-.56l-2.07-2.02c-.08-.07-.18-.11-.28-.11s-.2,.04-.28,.12l-2.02,2.02c-.15,.15-.15,.4,0,.56Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCargardocumentos);
export default __webpack_public_path__ + "static/media/Cargardocumentos.497575bcd0d4cdf519dbd936cee580e7.svg";
export { ForwardRef as ReactComponent };